<template>
  <div class="mobflex-window">
    <div class="ma-2 cus-brows-tabs">
      <div class="tab1">
        <v-card class="mt-6">
          <v-tabs
              v-model="tab"
              background-color="#32cd32"
              dark
              centered
              class="mb-2"
              show-arrows
              slider-size="5"
          >
            <v-tabs-slider color="#17408B"></v-tabs-slider>
            <!-- NBA-->
            <template v-if="defaultSport == '1'">
              <!-- tab 1 -->
              <v-tab exact :to="{ name: 'NbaProjection' }"> Props</v-tab>

              <!-- tab-2 -->
              <!--              <v-tab exact :to="{ name: 'NbaPropFinder' }">-->
              <!--                Prop Finder-->
              <!--              </v-tab>-->

              <!-- tab-3 -->
              <!--              <v-tab exact :to="{ name: 'NbaSportsBook' }">-->
              <!--                SportsBook-->
              <!--              </v-tab>-->
            </template>

            <!-- MLB -->
            <template v-if="defaultSport == '2'">
              <!-- tab 1 -->
              <v-tab exact :to="{ name: 'MlbProjection' }">
                Prop Analyzer
              </v-tab>

              <!-- tab-2 -->
              <!--              <v-tab exact :to="{ name: 'Mlbpropfinder' }"> Prop Finder</v-tab>-->

              <!-- tab-3 -->
              <!--              <v-tab exact :to="{ name: 'MlbSportsBook' }"> SportsBook</v-tab>-->

              <!-- tab-4 -->
              <v-tab exact :to="{ name: 'MlbBestBet' }" v-if="role === 'user'">
                Best Bet
              </v-tab>

              <!-- tab-5 -->
              <v-tab
                  exact
                  :to="{ name: 'MlbBestBetProps' }"
                  v-if="role === 'user'"
              >
                Best Bet Props
              </v-tab>
            </template>

            <!-- Nfl -->
            <template v-if="defaultSport == '4'">
              <!-- tab 1 -->
              <v-tab exact :to="{ name: 'NflProjection' }">
                Prop Analyzer
              </v-tab>

              <!--tab-2 -->
              <!--              <v-tab exact :to="{ name: 'Nflpropfinder' }">-->
              <!--                Prop Finder-->
              <!--              </v-tab>-->

              <!--tab-3 -->
              <!--              <v-tab exact :to="{ name: 'NflSportsBook' }">-->
              <!--                SportsBook-->
              <!--              </v-tab>-->

              <!-- tab-4 -->
              <v-tab exact :to="{ name: 'NflBestBet' }" v-if="role === 'user'">
                Best Bet
              </v-tab>

              <!-- tab-5 -->
              <v-tab
                  exact
                  :to="{ name: 'NflBestBetProps' }"
                  v-if="role === 'user'"
              >
                Best Bet Props
              </v-tab>
            </template>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <transition
                mode="out-in"
                enter-active-class="animate__animated animate__fadeInLeft animate__faster"
                leave-active-class="animate__animated animate__fadeOutRight animate__faster"
            >
              <router-view
                  :allSlate="this.allSlate"
                  :defaultSport="defaultSport"
                  :defaultOptimizer="defaultOptimizer"
              ></router-view>
            </transition>
          </v-tabs-items>
        </v-card>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Betting",
  props: ["allSlate", "defaultSport", "defaultOptimizer"],
  data() {
    return {
      tab: null,
      role: localStorage.getItem("role"),
    };
  },
};
</script>
<style scoped>
@media (max-width: 415px) {
  .team-a {
    margin-left: 20px;
  }

  .team-b {
    margin-left: 20px;
  }
}
</style>
